import React from 'react';
import { formatCurrency, formatInstallmentPlan, formatTna } from './contractSignatureFormatters';

const ContractSummaryCard = ({
  selectedOffer,
  clientData = null,
  firstDueDateLabel,
  contractUrl = '',
  onViewContract,
  onDownloadContract,
  showContractActions = true,
  variant = 'default'
}) => {
  const clientName = [clientData?.firstName, clientData?.lastName].filter(Boolean).join(' ');
  const clientLabel = clientName
    ? `${clientName}${clientData?.dni ? ` - DNI ${clientData.dni}` : ''}`
    : `DNI ${clientData?.dni || 'N/A'}`;
  const hasAmount = selectedOffer?.amount !== undefined && selectedOffer?.amount !== null && selectedOffer?.amount !== '';
  const isCompact = variant === 'compact';

  return (
    <section className={`rg-signature-summary${isCompact ? ' rg-signature-summary--compact' : ''}`} aria-label="Resumen del crédito">
      <div className="rg-signature-summary__header">
        <h5 className="rg-signature-summary__title">Resumen del crédito</h5>
        {showContractActions ? (
          <div className="rg-signature-summary__actions">
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              onClick={onViewContract}
              disabled={!contractUrl}
            >
              <i className="bi bi-eye me-1" aria-hidden="true"></i>
              Ver contrato
            </button>
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              onClick={onDownloadContract}
              disabled={!contractUrl}
            >
              <i className="bi bi-download me-1" aria-hidden="true"></i>
              Descargar contrato
            </button>
          </div>
        ) : null}
      </div>

      <div className="rg-signature-summary__grid">
        {isCompact && (
          <div className="rg-signature-summary__item rg-signature-summary__item--wide">
            <span className="rg-signature-summary__label">Cliente</span>
            <strong className="rg-signature-summary__value">{clientLabel}</strong>
          </div>
        )}

        {(!isCompact || hasAmount) && (
          <div className="rg-signature-summary__item">
            <span className="rg-signature-summary__label">Monto del crédito</span>
            <strong className="rg-signature-summary__value">{formatCurrency(selectedOffer?.amount)}</strong>
          </div>
        )}

        {isCompact ? (
          <>
            <div className="rg-signature-summary__item">
              <span className="rg-signature-summary__label">Cantidad de cuotas</span>
              <strong className="rg-signature-summary__value" title={formatInstallmentPlan(selectedOffer?.term, selectedOffer?.monthlyPayment)}>
                {Number(selectedOffer?.term || 0)}
              </strong>
            </div>
            <div className="rg-signature-summary__item">
              <span className="rg-signature-summary__label">Valor de cuota</span>
              <strong className="rg-signature-summary__value">{formatCurrency(selectedOffer?.monthlyPayment)}</strong>
            </div>
          </>
        ) : (
          <div className="rg-signature-summary__item">
            <span className="rg-signature-summary__label">Cuotas</span>
            <strong className="rg-signature-summary__value">
              {formatInstallmentPlan(selectedOffer?.term, selectedOffer?.monthlyPayment)}
            </strong>
          </div>
        )}

        {!isCompact && (
          <>
            <div className="rg-signature-summary__item">
              <span className="rg-signature-summary__label">TNA</span>
              <strong className="rg-signature-summary__value">{formatTna(selectedOffer?.interestRate)}</strong>
            </div>
            <div className="rg-signature-summary__item">
              <span className="rg-signature-summary__label">Primer vencimiento</span>
              <strong className="rg-signature-summary__value">{firstDueDateLabel}</strong>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default ContractSummaryCard;
